<template> 
<div>
  <div class="d-flex align-items-center justify-content-stretch div-list mb-3">

    <!-- NUMERO -->
    <div class="d-none d-lg-flex col-2 text-iptv justify-content-end align-items-center pt-2">
      <h3>{{number}}.</h3>
    </div>
    <div class="d-lg-none d-md-flex col-1 justify-content-end align-items-center pt-2">
        <h5>{{number}}.</h5>
    </div>

    <!-- IMMAGINE -->
    <div class="d-none d-xl-flex col-3 justify-content-start align-items-center p-2">
        <img :src="images" class="border rounded p-1" width="90px;" height="50px;"> 
    </div>
    <div class="d-lg-none d-md-flex col-5 px-1 justify-content-start align-items-center p-2">
        <img :src="images" class="border rounded p-1 " width="60px;" height="30px;"> 
    </div>
    <div class="d-none d-lg-flex d-xl-none col-6 px-1 justify-content-start align-items-center p-2">
        <img :src="images" class="border rounded p-1 justify-content-center align-items-center" width="90px;" height="50px;"> 
    </div>

    <!-- SIGLA -->

    <div class="d-none d-lg-flex d-xl-none col-5 justify-content-center align-items-center p-2">
        <h4 class=""><span v-html="sigla"></span></h4>
    </div>
    <div class="d-lg-none d-md-flex col-6 justify-content-center align-items-center pt-2">
        <h4 class=""><span v-html="sigla"></span></h4>
    </div>
    <div class="d-none d-xl-flex col-7 justify-content-center align-items-center pt-2">
        <h3 class=""><span v-html="sigla"></span></h3>
    </div>

  </div>
      
</div> 

    
</template>

<script>

///import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'TvCard',
  data: function() {
    return  {
      
    };
  },
  props: ['images','sigla', 'number'],
  methods: {    
  },
  computed: {    
  }
}
</script>


